import Column from '@app/components/layout/Column'
import { FollowedHousingForms } from './FollowedHousingForms'
import { InterestListInitiatives } from './InterestListInitiatives'
import { FollowedPlots } from './FollowedPlots'
import { FollowedRegions } from './FollowedRegions'

export const InterestListTab = () => {
  return (
    <Column alignItems="stretch" gap="2rem">
      <InterestListInitiatives />
      <FollowedPlots />
      <FollowedRegions />
      <FollowedHousingForms />
    </Column>
  )
}
